import { Injectable } from '@angular/core';
import { defaultDateFormatOptions } from '@config';
import { ErrorMessageTokenPattern, ErrorMessageTokenType, FileInputModel, getAllowedFileExtensions, getAllowedFileSizeBytes, InputItemModel } from '@libs/form/models';
import { DateTime } from 'luxon';

@Injectable({
  providedIn: 'root',
})
export class ErrorTokenReplacer {
  public replaceTokens(message: string, data: InputItemModel): string {
    return message.replace(
      ErrorMessageTokenPattern,
      (token: string) => this.getTokenReplacement(token, data),
    );
  }

  private getTokenReplacement(token: string, data: InputItemModel): string {
    let replacement: string | undefined;

    switch (token as ErrorMessageTokenType) {
      case '@label': {
        replacement = data.labelInfo ?? data.label;

        break;
      }
      case '@minLength': {
        replacement = data.attributes?.minLength?.toString();

        break;
      }
      case '@maxLength': {
        replacement = data.attributes?.maxLength?.toString();

        break;
      }
      case '@minDate': {
        const parsedDate: DateTime = DateTime.fromISO(data.attributes?.min ?? '');

        if (!parsedDate.isValid) {
          replacement = undefined;

          break;
        }

        replacement = parsedDate.toLocaleString(defaultDateFormatOptions);

        break;
      }
      case '@maxDate': {
        const parsedDate: DateTime = DateTime.fromISO(data.attributes?.max ?? '');

        if (!parsedDate.isValid) {
          replacement = undefined;

          break;
        }

        replacement = parsedDate.toLocaleString(defaultDateFormatOptions);

        break;
      }
      case '@minCount': {
        replacement = data.attributes?.minCount?.toString();

        break;
      }
      case '@fileMaxSize': {
        replacement = String(getAllowedFileSizeBytes(data as FileInputModel) / (1024 * 1024));

        break;
      }
      case '@fileType': {
        replacement = getAllowedFileExtensions(data as FileInputModel).join(', ').toUpperCase();

        break;
      }
    }

    return replacement ?? token;
  }
}
